import React, { useEffect, useState, useRef } from "react";
import { Button, Spin, message, Radio, Typography, Grid } from "antd";
import "./Appointmenttype.css";
import {
  ArrowLeftOutlined,
  DownOutlined,
  RightOutlined,
  ExportOutlined,
  DeleteOutlined, EditOutlined, EyeOutlined,
  ExclamationCircleOutlined,
  MedicineBoxOutlined, HeartOutlined, BankOutlined, PlusOutlined,
  HolderOutlined,
  VideoCameraOutlined, ExperimentOutlined, SafetyOutlined, TeamOutlined,
  UserOutlined, GlobalOutlined, CalendarOutlined, ClockCircleOutlined,
  PhoneOutlined, FileTextOutlined, StarOutlined, SmileOutlined,
  CompassOutlined, CustomerServiceOutlined, ReconciliationOutlined,
  CrownOutlined, ThunderboltOutlined, TrophyOutlined,
  SecurityScanOutlined, AuditOutlined, AlertOutlined, LikeOutlined,
  AppstoreOutlined, SearchOutlined, CloseOutlined,
  SkinOutlined, ZoomInOutlined, WomanOutlined, ManOutlined,
  FireOutlined, BulbOutlined, ApartmentOutlined,
  SafetyCertificateOutlined, ShareAltOutlined,
  AudioOutlined, EnvironmentOutlined, IdcardOutlined, DashboardOutlined,
  CoffeeOutlined, RestOutlined, BugOutlined, ScissorOutlined,
  PlusSquareOutlined, HomeOutlined, ShopOutlined, LineChartOutlined, AimOutlined
} from "@ant-design/icons";
import { spacerData } from "./CommonApiCallCalender";
import generateSessionEventPush from "../BookingJourney/StepComponents/sessionEventPush";
const { Title, Text } = Typography;

const iconMapping = {
  DeleteOutlined: <DeleteOutlined />,
  EditOutlined: <EditOutlined />,
  EyeOutlined: <EyeOutlined />,
  ExclamationCircleOutlined: <ExclamationCircleOutlined />,
  MedicineBoxOutlined: <MedicineBoxOutlined />,
  HeartOutlined: <HeartOutlined />,
  BankOutlined: <BankOutlined />,
  PlusOutlined: <PlusOutlined />,
  HolderOutlined: <HolderOutlined />,
  VideoCameraOutlined: <VideoCameraOutlined />,
  ExperimentOutlined: <ExperimentOutlined />,
  SafetyOutlined: <SafetyOutlined />,
  TeamOutlined: <TeamOutlined />,
  UserOutlined: <UserOutlined />,
  GlobalOutlined: <GlobalOutlined />,
  CalendarOutlined: <CalendarOutlined />,
  ClockCircleOutlined: <ClockCircleOutlined />,
  PhoneOutlined: <PhoneOutlined />,
  FileTextOutlined: <FileTextOutlined />,
  StarOutlined: <StarOutlined />,
  SmileOutlined: <SmileOutlined />,
  CompassOutlined: <CompassOutlined />,
  CustomerServiceOutlined: <CustomerServiceOutlined />,
  ReconciliationOutlined: <ReconciliationOutlined />,
  CrownOutlined: <CrownOutlined />,
  ThunderboltOutlined: <ThunderboltOutlined />,
  TrophyOutlined: <TrophyOutlined />,
  SecurityScanOutlined: <SecurityScanOutlined />,
  AuditOutlined: <AuditOutlined />,
  AlertOutlined: <AlertOutlined />,
  LikeOutlined: <LikeOutlined />,
  AppstoreOutlined: <AppstoreOutlined />,
  SearchOutlined: <SearchOutlined />,
  CloseOutlined: <CloseOutlined />,
  SkinOutlined: <SkinOutlined />,
  ZoomInOutlined: <ZoomInOutlined />,
  WomanOutlined: <WomanOutlined />,
  ManOutlined: <ManOutlined />,
  FireOutlined: <FireOutlined />,
  BulbOutlined: <BulbOutlined />,
  ApartmentOutlined: <ApartmentOutlined />,
  SafetyCertificateOutlined: <SafetyCertificateOutlined />,
  ShareAltOutlined: <ShareAltOutlined />,
  AudioOutlined: <AudioOutlined />,
  EnvironmentOutlined: <EnvironmentOutlined />,
  IdcardOutlined: <IdcardOutlined />,
  DashboardOutlined: <DashboardOutlined />,
  CoffeeOutlined: <CoffeeOutlined />,
  RestOutlined: <RestOutlined />,
  BugOutlined: <BugOutlined />,
  ScissorOutlined: <ScissorOutlined />,
  PlusSquareOutlined: <PlusSquareOutlined />,
  HomeOutlined: <HomeOutlined />,
  ShopOutlined: <ShopOutlined />,
  LineChartOutlined: <LineChartOutlined />,
  AimOutlined: <AimOutlined />
};

const IconMapper = ({ iconName }) => {
  const IconComponent = iconMapping[iconName];
  return IconComponent ? IconComponent : <RightOutlined />;
};

const AppointmenttypeV2 = (props) => {
  const continueButtonRef = useRef(null);

  const [SelectedAppointmentData, setSelectedAppointmentData] = useState(() => {
    const defaultCategoryId = props.productCategoryId || null;
    const defaultProdcat = (props.options || []).find(
      (opt) => opt.product_category_id === Number(defaultCategoryId)
    );

    const initialData = {};

    if (props.productId) {
      initialData.non_gp_product_id = props.productId;
    }

    if (defaultProdcat) {
      initialData.productCategory = defaultProdcat;
    }

    return Object.keys(initialData).length > 0 ? initialData : null;
  });

  const [messageApi, contextHolder] = message.useMessage();
  const [corporateData, setCorporateData] = useState({});
  const [loading, setLoader] = useState(false);
  const [visibleSubProductsCount, setVisibleSubProductsCount] = useState(6);
  let productId = props.productId ? props.productId : null;

  const initialSelectedClinics = productId ? [String(productId)] : [];
  const [selectedClinics, setSelectedClinics] = useState(
    initialSelectedClinics
  );
  const [healthBooking, setHealthBooking] = useState(false);
  const [options, setOptions] = useState(props?.options || []);
  const hashCode = props?.hashCode || "";
  const partnerId = props?.partnerId || "";
  const showContinueForAutoSelected = !!props.productCategoryId && !!props.productId;

  let filteredData;
  const selectedCategoryId = SelectedAppointmentData?.productCategory?.product_category_id;
  const selectedCategoryType = SelectedAppointmentData?.productCategory?.type;

  const hsData =
    props?.getAllHealthScreenData?.getAllHealthScreenData?.data?.filter(
      (product) =>
        product.product_category_id == selectedCategoryId ||
        product.product_category_type == selectedCategoryId
    );

  const corporateProductData =
    props?.getAllHealthScreenData?.getAllHealthScreenData?.data?.filter(
      (product) =>
        product.product_category_id == selectedCategoryId ||
        product.product_category_type == selectedCategoryId
    );

  if (partnerId) {
    // Partner mode: only show the single category built from the partner API response.
    // Use props.options directly (not local state) so we always reflect the latest
    // data from UnifiedAppointmentType, not a potentially-stale useState initialisation.
    filteredData = props.options || [];
  } else if (hashCode) {
    filteredData = options.filter((item) => item.type === "corporate");
  } else {
    const allSubProducts = props?.getAllHealthScreenData?.getAllHealthScreenData?.data || [];
    filteredData = options.filter((item) => {
      if (item.type === "corporate") return false;

      // For d2c categories, only show them if they have active sub-products
      if (item.type === "d2c") {
        const hasSubProducts = allSubProducts.some(
          (sub) =>
            (sub.product_category_id == item.product_category_id ||
              sub.product_category_type == item.product_category_id) &&
            (sub.status == 1 || sub.status === true)
        );
        return hasSubProducts;
      }

      return true;
    });
  }

  // ── DF-06: Defer corporate/partner hash fetch to after initial paint ───────────────────
  // The category list renders immediately; corporate data overlays when ready.
  useEffect(() => {
    if (!hashCode && !partnerId) return;
    const run = () => getCorporatProducts();
    if (typeof requestIdleCallback !== 'undefined') {
      requestIdleCallback(run, { timeout: 1500 });
    } else {
      setTimeout(run, 0);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const getCorporatProducts = async () => {
    // Use partnerId if present, otherwise fall back to hashCode
    const lookupKey = partnerId || hashCode;
    const product = await spacerData(
      `get-corporate-customers/${lookupKey}`,
      null,
      null,
      false
    );
    const corporateResponse = product?.data?.data;
    setCorporateData(corporateResponse);

    // ── category_customization: per-category label overrides ─────────────────
    const categoryCustomization = corporateResponse?.category_customization;

    if (Array.isArray(categoryCustomization) && categoryCustomization.length > 0) {
      // Build a lookup map: product_category_id -> label
      const labelMap = {};
      categoryCustomization.forEach((cat) => {
        if (cat.change_category_label && cat.product_category_label) {
          labelMap[cat.product_category_id] = {
            title: cat.product_category_label,
            description: cat.product_category_description || "",
          };
        }
      });

      if (Object.keys(labelMap).length > 0) {
        setOptions((prevOptions) =>
          prevOptions.map((option) => {
            const override = labelMap[option.product_category_id];
            return override
              ? { ...option, title: override.title, description: override.description }
              : option;
          })
        );

        setSelectedAppointmentData((prevData) => {
          const override = labelMap[prevData?.productCategory?.product_category_id];
          if (override) {
            return {
              ...prevData,
              productCategory: {
                ...prevData.productCategory,
                title: override.title,
                description: override.description,
              },
            };
          }
          return prevData;
        });
      }
    } else if (corporateResponse?.change_category_label || partnerId) {
      // Legacy fallback: single label applied to all corporate/d2c categories
      const labelToApply = corporateResponse?.product_category_label;
      if (labelToApply) {
        setOptions((prevOptions) =>
          prevOptions.map((option) =>
            (option.type === "corporate" || option.type === "d2c")
              ? { ...option, title: labelToApply }
              : option
          )
        );

        setSelectedAppointmentData((prevData) => {
          if (
            prevData?.productCategory?.type === "corporate" ||
            prevData?.productCategory?.type === "d2c"
          ) {
            return {
              ...prevData,
              productCategory: {
                ...prevData.productCategory,
                title: labelToApply,
              },
            };
          }
          return prevData;
        });
      }
    }
    setLoader(false);
  };

  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  const submitAppointment = (dataToSubmit) => {
    generateSessionEventPush({
      module: "booking",
      log_name: "BookingJourney",
      event: "booking_flow_started",
      payload: {
        appointment_type: dataToSubmit?.productCategory?.product_category_id,
        appointment_type_name: dataToSubmit?.productCategory?.title,
        selected_product: dataToSubmit?.productData?.name || null,
        selected_product_id:
          dataToSubmit?.non_gp_product_id ||
          dataToSubmit?.corporate_product_id ||
          null,
        screen: "step_1",
        user_type: "PBJ",
        selected_date: new Date().toISOString().split("T")[0],
      },
    });
    props.callback({ ...dataToSubmit, corporateData }, "BookingForm");
  };

  const handleClinicChange = (e, type) => {
    const value = e.target.value;
    const checked = e.target.checked;

    setSelectedClinics((prev) => {
      if (checked) {
        if (prev.length >= 1) {
          messageApi.error({
            type: "error",
            content: "You can select only one option.",
          });
          return prev;
        } else {
          return [...prev, value.toString()];
        }
      } else {
        return prev.filter((item) => item !== value);
      }
    });
    if (type == "GP") {
      setSelectedAppointmentData((prev) => ({ ...prev, gp_product_id: value }));
    } else if (type == "HC") {
      setSelectedAppointmentData((prev) => ({
        ...prev,
        non_gp_product_id: value,
      }));
    }
  };

  const selectAppointmentCategoryData = (prodcat) => {
    if (prodcat.type === "video") {
      window.open(
        "https://ldc-online-booking.semble.io/?token=2a453adcfcb727cfd1e91f3e245edcd360931ec3",
        "_blank"
      );
      return;
    }

    if (prodcat.type === "gp") {
      const updatedData = { productCategory: prodcat };
      setSelectedAppointmentData(updatedData);
      submitAppointment(updatedData);
      return;
    }

    if (SelectedAppointmentData?.productCategory?.product_category_id === prodcat.product_category_id) {
      setSelectedAppointmentData({ productCategory: null });
      setSelectedClinics([]);
      return;
    }

    setSelectedClinics([]);
    setSelectedAppointmentData({ productCategory: prodcat });
    setVisibleSubProductsCount(6);
  };

  const priorityOrder = [
    "Vital",
    "Bronze",
    "Silver",
    "Gold",
    "Platinum",
    "Diamond",
  ];
  const sortedProducts = (hashCode || partnerId)
    ? (() => {
      // In partner mode with multiple categories, filter by the selected category id
      const allCorporateProducts = corporateData?.corporate_products
        ?.filter((product) => product.status == 1 || product.status === true);

      // If there is a selected category (from category_customization), scope to that category
      if (partnerId && selectedCategoryId && allCorporateProducts) {
        return allCorporateProducts
          .filter((p) =>
            p.product_category_id == selectedCategoryId ||
            p.product_category_type == selectedCategoryId
          )
          .sort((a, b) => {
            const orderA = a?.display_order ?? a?.sort_order ?? 0;
            const orderB = b?.display_order ?? b?.sort_order ?? 0;
            return orderA - orderB;
          });
      }

      // Default corporate/hash mode: no category filter
      return allCorporateProducts?.sort((a, b) => {
        const orderA = a?.display_order ?? a?.sort_order ?? 0;
        const orderB = b?.display_order ?? b?.sort_order ?? 0;
        return orderA - orderB;
      });
    })()
    : hsData
      ?.filter((product) => {
        const isActive = product.status == 1 || product.status === true;
        return isActive;
      })
      .sort((a, b) => {
        const orderA = a?.display_order ?? a?.sort_order ?? 0;
        const orderB = b?.display_order ?? b?.sort_order ?? 0;
        return orderA - orderB;
      });

  useEffect(() => {
    if (!showContinueForAutoSelected || !SelectedAppointmentData?.non_gp_product_id) {
      return;
    }

    if (SelectedAppointmentData?.productData) {
      return;
    }

    const selectedProduct = sortedProducts?.find(
      (product) =>
        String(product?.non_gp_product_id) ===
        String(SelectedAppointmentData?.non_gp_product_id)
    );

    if (selectedProduct) {
      setSelectedAppointmentData((prev) => ({
        ...prev,
        productData: selectedProduct,
      }));
    }
  }, [
    showContinueForAutoSelected,
    sortedProducts,
    SelectedAppointmentData?.non_gp_product_id,
    SelectedAppointmentData?.productData,
  ]);

  // Partner mode with multiple categories: do NOT auto-expand.
  // With category_customization the user should choose which category to open.
  // Only auto-expand when there is exactly ONE partner category (legacy single-category flow).
  useEffect(() => {
    if (!partnerId) return;
    const partnerOptions = props.options || [];
    if (partnerOptions.length === 1 && !SelectedAppointmentData?.productCategory) {
      setSelectedAppointmentData({ productCategory: partnerOptions[0] });
    }
  }, [partnerId, props.options]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div
      className="apptSection"
      style={{ maxWidth: "605px", margin: "auto", textAlign: "center" }}
    >
      {contextHolder}
      {loading ? (
        <Spin className="custom-spinner" />
      ) : (
        <>
          {corporateData && corporateData?.company_logo && (
            <img
              src={corporateData?.company_logo}
              style={{ marginTop: "50px", maxWidth: "300px" }}
              alt="Company Logo"
            />
          )}
          <div
            style={{
              background: "#00838540",
              padding: 10,
              marginBottom: 20,
              marginTop: screens.md ? "50px" : "0px",
            }}
          >
            <Title
              level={4}
              style={{
                margin: 0,
                color: "#008385",
                fontWeight: "400",
                size: "20px",
                lineHeight: "100%",
                letterSpacing: "0.3px",
              }}
              className="textalign"
            >
              Appointment type
            </Title>
          </div>
          {filteredData &&
            filteredData.length &&
            filteredData.map((prodcat, i) => {
              const isSelected =
                prodcat.product_category_id ==
                SelectedAppointmentData?.productCategory?.product_category_id;
              const isHealth =
                isSelected &&
                (SelectedAppointmentData?.productCategory?.type === "d2c" ||
                  SelectedAppointmentData?.productCategory?.type === "corporate");
              const hasDescription = !!prodcat?.description;
              let divClass = "apptTypeBox";
              if (prodcat.type === "video") divClass += " aptType";
              if (isSelected) divClass += " selected";
              if (isHealth) divClass += " health";
              if (hasDescription) divClass += " hasDescription";
              return (
                <React.Fragment key={prodcat.product_category_id}>
                  <div className={divClass}>
                    <div class="aptv2-category-indicator" aria-hidden="true"></div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "start",
                        alignItems: "center",
                        textAlign: "center",
                        position: "relative",
                        paddingLeft: screens?.md ? "10%" : "4%",
                        paddingBottom: isHealth ? "0%" : "0%",
                      }}
                      onClick={() => selectAppointmentCategoryData(prodcat)}
                    >
                      <div style={{
                        backgroundColor: isSelected ? "#008385" : "#E6F4F4",
                        color: isSelected ? "#ffffff" : "#008385",
                        borderRadius: "8px",
                        width: "48px",
                        height: "48px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginRight: "16px",
                        fontSize: "24px"
                      }}>
                        <IconMapper iconName={prodcat.icon_name} />
                      </div>
                      <div
                        style={{
                          marginRight: "0",
                          cursor: "pointer",
                          textAlign: "left",
                          width: "70%",
                          display: prodcat?.description ? "block" : "flex",
                          alignItems: "center",
                        }}
                      >
                        <div>
                          {prodcat.title && (
                            <Title
                              level={5}
                              style={{
                                margin: 0,
                                color: "rgba(74, 74, 74, 1)",
                                fontWeight: "bold",
                                size: "20px",
                                lineHeight: "100%",
                                letterSpacing: "0.3px",
                                paddingBottom: prodcat?.description ? "7px" : "0px",
                              }}
                            >
                              {prodcat.title}
                            </Title>
                          )}
                          {prodcat.description && (
                            <Text type="secondary" style={{ maxWidth: "70%", fontSize: "12px" }}>
                              {" "}
                              {prodcat.description}
                            </Text>
                          )}
                        </div>
                      </div>

                      <div style={{ position: "absolute", right: "5%", color: "#008385" }}>
                        {prodcat.type === "video" ? (
                          <ExportOutlined />
                        ) : isHealth ? (
                          <DownOutlined />
                        ) : (
                          <RightOutlined />
                        )}
                      </div>
                    </div>
                  </div>
                  <Radio.Group
                    value={
                      Array.isArray(selectedClinics)
                        ? selectedClinics[0]
                        : selectedClinics
                    }
                    style={{
                      backgroundColor: "#FAFAFA",
                      width: "100%",
                      maxWidth: "605px",
                      display: isHealth ? "block" : "none",
                      border: "1px solid #EAEAEA",
                      borderTop: "none",
                    }}
                    onChange={(e) => {
                      let productKey =
                        sortedProducts &&
                        sortedProducts.length &&
                        sortedProducts.find(
                          (product) =>
                            product.non_gp_product_id == e.target.value
                        );
                      setSelectedClinics([e.target.value]);

                      const updatedData = {
                        ...SelectedAppointmentData,
                        non_gp_product_id: e.target.value,
                        productData: productKey,
                      };
                      setSelectedAppointmentData(updatedData);

                      if (!showContinueForAutoSelected) {
                        submitAppointment(updatedData);
                      }
                    }}
                  >
                    {isHealth
                      ? sortedProducts &&
                      sortedProducts.length > 0 &&
                      sortedProducts.slice(0, visibleSubProductsCount).map((hcData) => {
                        return (
                          <div style={{ paddingTop: 15, paddingBottom: 15, borderBottom: "1px solid #EAEAEA" }} key={hcData.non_gp_product_id}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "flex-start",
                                paddingLeft: screens?.md ? "calc(10% + 15px)" : "calc(4% + 4px)",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "start",
                                  marginRight: 10,
                                  cursor: "pointer",
                                }}
                              >
                                <Radio
                                  value={hcData?.non_gp_product_id?.toString()}
                                  checked={
                                    (Array.isArray(selectedClinics)
                                      ? selectedClinics.includes(
                                        hcData?.non_gp_product_id?.toString()
                                      )
                                      : String(selectedClinics) ===
                                      hcData?.non_gp_product_id?.toString()) ||
                                    String(productId) ===
                                    hcData?.non_gp_product_id?.toString()
                                  }
                                  className="round-checkbox"
                                ></Radio>
                              </div>
                              <div
                                style={{ width: "400px", fontSize: "15px" }}
                              >
                                <div
                                  style={{
                                    textAlign: "left",
                                    fontSize: "16px ",
                                    fontWeight: "400",
                                    color: "#4A4A4A",
                                  }}
                                >
                                  {hcData.name}
                                </div>
                                <div
                                  className="mobile-copy html-content"
                                  dangerouslySetInnerHTML={{
                                    __html:
                                      hcData.product_specific_booking_page_short_copy,
                                  }}
                                />
                                <div
                                  className="desktop-copy html-content"
                                  dangerouslySetInnerHTML={{
                                    __html:
                                      hcData.product_specific_booking_page_long_copy,
                                  }}
                                />

                                {healthBooking
                                  ? ""
                                  : setHealthBooking(true)}

                                {((Array.isArray(selectedClinics)
                                  ? selectedClinics.includes(
                                    hcData?.non_gp_product_id?.toString()
                                  )
                                  : String(selectedClinics) ===
                                  hcData?.non_gp_product_id?.toString()) ||
                                  (String(productId) ===
                                    hcData?.non_gp_product_id?.toString())) && (
                                    <div>
                                      {hcData?.checks &&
                                        hcData?.checks?.general?.length >
                                        0 && (
                                          <div>
                                            <ul style={{ margin: "0px" }}>
                                              {hcData.checks.general.map(
                                                (item, index) => (
                                                  <li
                                                    key={index}
                                                    style={{
                                                      color: "#4A4A4A",
                                                      fontWeight: "500",
                                                      fontSize: "12px",
                                                      textAlign: "left",
                                                    }}
                                                  >
                                                    {item}
                                                  </li>
                                                )
                                              )}
                                            </ul>
                                          </div>
                                        )}

                                      {hcData?.checks?.male_specific
                                        ?.length > 0 && (
                                          <div>
                                            <div
                                              style={{
                                                color: "#4A4A4A",
                                                fontWeight: "600",
                                                fontSize: "12px",
                                                textAlign: "left",
                                                margin: "10px 0px",
                                              }}
                                            >
                                              Male-specific Checks:
                                            </div>
                                            <ul>
                                              {hcData.checks.male_specific.map(
                                                (item, index) => (
                                                  <li
                                                    key={index}
                                                    style={{
                                                      color: "#4A4A4A",
                                                      fontWeight: "500",
                                                      fontSize: "12px",
                                                      textAlign: "left",
                                                    }}
                                                  >
                                                    {item}
                                                  </li>
                                                )
                                              )}
                                            </ul>
                                          </div>
                                        )}

                                      {hcData?.checks?.female_specific
                                        ?.length > 0 && (
                                          <div>
                                            <div
                                              style={{
                                                color: "#4A4A4A",
                                                fontWeight: "600",
                                                fontSize: "12px",
                                                textAlign: "left",
                                                margin: "10px 0px",
                                              }}
                                            >
                                              Female-specific Checks:
                                            </div>
                                            <ul>
                                              {hcData.checks.female_specific.map(
                                                (item, index) => (
                                                  <li
                                                    key={index}
                                                    style={{
                                                      color: "#4A4A4A",
                                                      fontWeight: "500",
                                                      fontSize: "12px",
                                                      textAlign: "left",
                                                    }}
                                                  >
                                                    {item}
                                                  </li>
                                                )
                                              )}
                                            </ul>
                                          </div>
                                        )}
                                    </div>
                                  )}
                              </div>
                              <br />
                            </div>
                          </div>
                        );
                      })
                      : ""}

                    {isHealth && sortedProducts && sortedProducts.length > visibleSubProductsCount && (
                      <div style={{ textAlign: "center", paddingTop: "15px", paddingBottom: "15px", borderTop: "1px dashed #EAEAEA" }}>
                        <Button
                          type="link"
                          onClick={() => setVisibleSubProductsCount(sortedProducts.length)}
                          style={{ color: "#008385", fontWeight: "bold" }}
                        >
                          Show {sortedProducts.length - visibleSubProductsCount} more options
                        </Button>
                      </div>
                    )}
                  </Radio.Group>
                </React.Fragment>
              );
            })}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "20px",
              marginTop: "20px",
              marginBottom: "20px",
            }}
          >
            {showContinueForAutoSelected && (
              <Button
                type="primary"
                ref={continueButtonRef}
                style={{
                  ...((!SelectedAppointmentData?.productCategory || !SelectedAppointmentData?.non_gp_product_id) ? {} : { backgroundColor: "#008385", borderColor: "#008385" })
                }}
                disabled={!SelectedAppointmentData?.productCategory || !SelectedAppointmentData?.non_gp_product_id}
                onClick={() => submitAppointment(SelectedAppointmentData)}
              >
                Continue
              </Button>
            )}

            {!props.ContinueButoonStylingMiddle && (
              <Button
                icon={
                  <ArrowLeftOutlined
                    style={{ color: "#008385", fontSize: "18px" }}
                  />
                }
                onClick={() => props.callBackForbackpage(null)}
                className="backBtn"
              >
                Back
              </Button>
            )}
          </div>
          <style jsx>
            {`
              .html-content p,
              .html-content h1,
              .html-content h2,
              .html-content ul,
              .html-content b,
              .html-content strong,
              .html-content li {
                font-weight: 400 !important;
                margin: 0 !important;
                padding: 0;
              }

              .html-content em {
                font-style: normal;
                color: inherit;
              }
            `}
          </style>
        </>
      )}
    </div>
  );
};

export default AppointmenttypeV2;
